import script from "./MoreFeaturesSlide.vue?vue&type=script&setup=true&lang=js"
export * from "./MoreFeaturesSlide.vue?vue&type=script&setup=true&lang=js"

import "./MoreFeaturesSlide.vue?vue&type=style&index=0&id=d1dd3888&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1dd3888"]])

export default __exports__